import React from 'react';
import BaseAutoComplete from '../base-auto-complete';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
import { isJson } from '../../util/validationHelpers';
const LABELS = {
  ARHI: DEFAULT_LABELS.ADDRESS_LOOKUP
};
const getFieldGroupPrefix = fieldName => fieldName.split('--')[0];
const getFieldsObject = (id, itemsJsonString) => {
  const fields = JSON.parse(itemsJsonString);
  const fieldGroupPrefix = getFieldGroupPrefix(id);
  return {
    [`${fieldGroupPrefix}--streetAddress`]: fields.AddressLine,
    [`${fieldGroupPrefix}--suburb`]: fields.Locality,
    [`${fieldGroupPrefix}--states`]: fields.State,
    [`${fieldGroupPrefix}--postcode`]: fields.Postcode,
    [id]: `${fields.AddressLine}, ${fields.Locality} ${fields.State} ${fields.Postcode}` // Downshift gives the search field it's own ID, this confuses Formik.
  };
};
const clearFields = (setFieldValue, id) => {
  const name = getFieldGroupPrefix(id);
  setFieldValue(id, '');
  setFieldValue(`${name}--streetAddress`, '');
  setFieldValue(`${name}--suburb`, '');
  setFieldValue(`${name}--states`, '');
  setFieldValue(`${name}--postcode`, '');
};
const multiFieldChangeEvent = (id, items, form) => {
  // in the event that a user selects the "enter address manually" link then a function is passed through rather than a strinfyified JSON obj
  const isManualAddLinkItem = typeof items === 'function';
  if (isManualAddLinkItem) {
    items();
    return null;
  }
  if (!isJson(items)) {
    clearFields(form.setFieldValue, id);
    return null;
  }
  Object.entries(getFieldsObject(id, items)).forEach(_ref => {
    let [key, value] = _ref;
    form.setFieldValue(key, value);
    form.setFieldTouched(key, value);
  });
};
const AusAddressLookup = props => {
  var _a;
  const {
    label,
    width = 30,
    help,
    input,
    field,
    stateToFilterOn,
    kleberApiKey,
    required,
    ...otherProps
  } = props;
  return React.createElement(BaseAutoComplete, {
    isAddressLookup: true,
    kleberApiKey: kleberApiKey,
    label: label || LABELS[(_a = props.funnel) !== null && _a !== void 0 ? _a : ''] || LABELS.ARHI,
    help: help,
    width: width,
    keys: ['value', 'text', 'aliases'],
    field: field,
    input: input,
    stateToFilterOn: stateToFilterOn,
    formikOnChange: multiFieldChangeEvent,
    ...otherProps
  });
};
AusAddressLookup.defaultProps = {
  stateToFilterOn: ''
};
const AusAddressLookupWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AusAddressLookup, {
  ...props
}));
export default AusAddressLookupWithFunnel;